import { render, staticRenderFns } from "./CreateUserModule.vue?vue&type=template&id=5ab4b1bf&scoped=true&"
import script from "./CreateUserModule.vue?vue&type=script&lang=js&"
export * from "./CreateUserModule.vue?vue&type=script&lang=js&"
import style0 from "./CreateUserModule.vue?vue&type=style&index=0&id=5ab4b1bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab4b1bf",
  null
  
)

export default component.exports